export default __webpack_public_path__ + "static/media/emptycart.aa463ca5.svg";